import api from './api';
import { formatISO9075 } from 'date-fns';
import validator from 'validator';

function parseEmails(raw) {
  if (!raw || raw.trim() === '') return [];
  return raw
    .split(/[\n,]+/)
    .map(e => e.trim())
    .filter(e => e.length > 0);
}

function validateTokenData(tokenData) {
  const errors = {};

  if (tokenData.created_at_epoch) {
    try {
      tokenData.created_at_epoch = formatISO9075(tokenData.created_at_epoch);
    } catch (e) {
      errors.created_at_epoch = ['created_at_epoch is invalid'];
    }
  }

  const emailsArray = parseEmails(tokenData.emails || '');
  if (emailsArray.length === 0) {
    errors.emails = ['Emails are required'];
  } else if (!emailsArray.every(email => validator.isEmail(email))) {
    errors.emails = ['One or more emails are invalid'];
  } else {
    tokenData.emails = emailsArray;
  }

  return errors;
}

const callEndpoint = async (method, tokenData) => {
  const { data } = await api.request(`/oauth/revoke_tokens_for_emails`, {
    method, body: tokenData, authenticated: true,
  });
  return data;
};

export default {
  async revokeTokensForEmails(tokenData) {
    const errors = validateTokenData(tokenData);
    if (Object.keys(errors).length > 0) {
      const error = new Error('Validation failed');
      error.errors = errors;
      throw error;
    }
    return callEndpoint('POST', tokenData);
  },
};
